<template>
  <div id="prototype">
    <el-container class="html-con">
        <el-main class="main-con">
            <el-tabs>
              <el-tab-pane label="客户总览" name="first">
                

                <!--  第一个tabs -->
                <el-row :gutter="10">
                  <el-col :span="24" class="bctabpanbgline"></el-col>
                  <el-col :span="14"><div class="grid-content bg-purple">
                    <el-card class="box-card box-card-hbg">
                      <div slot="header" class="clearfix">
                        <span>资产总览</span>
                      </div>
                      
                      <el-row :gutter="10">
                        <el-col :span="12">
                          <img src="../assets/images/img03.jpg" width="100%">
                        </el-col>
                        <el-col :span="12">
                          <div class="car-mesg-all of">
                            <div class="car-title">车辆信息（共 <span>2</span> 辆）</div>
                            <div class="car-mesg">苏NF8879<br/>箱式4.2米<4吨<10.3m³</div>
                            <div class="car-foot">现估值：250,000元</div>
                          </div>
                        </el-col>
                      </el-row>
                    </el-card>
                  </div></el-col>
                  <el-col :span="10"><div class="grid-content bg-purple">
                    <el-card class="box-card box-card-hbg">
                      <div slot="header" class="clearfix">
                        <span>授信额度</span>
                        <el-button style="float: right; padding: 3px 0" type="text">授信记录</el-button>
                      </div>
                      <el-row :gutter="10">
                        <el-col :span="24">
                          <div class="text-top-mesg">可用额度：<span>32000元/50000元</span>&nbsp;&nbsp;<el-button size="mini">提额</el-button></div> 
                        </el-col>
                        <el-col :span="14">
                          <img src="../assets/images/img05.jpg" width="100%">
                        </el-col>
                        <el-col :span="10">
                          <ul class="shouxinedu-mesg of">
                            <p>授信产品额度</p>
                            <li><a>快享贷1</a><span>10000</span></li>
                            <li><a>快享贷2</a><span>20000</span></li>
                            <li><a>快享贷3</a><span>30000</span></li>
                            <li><a>合计</a><span>60000</span></li>
                          </ul>
                        </el-col>
                      </el-row>
                    </el-card>
                  </div></el-col>
                  <el-col :span="24" class="bctabpanbgline"></el-col>
                  <el-col :span="9"><div class="grid-content bg-purple">
                    <el-card class="box-card box-card-hbg">
                      <div slot="header" class="clearfix">
                        <span>客户合同</span>
                      </div>
                      <ul class="cust-hetong of">
                        <li>
                          <div class="cust-hetong-mesg">
                            <p>合同编号：</p>
                          </div>
                          <div class="cust-hetong-mesg">
                            <p>期限：</p>
                          </div>
                          <div class="cust-hetong-mesg">
                            <p>贷款月利率：</p>
                          </div>
                          <div class="cust-hetong-jiaobiao">
                            <p>快享贷</p>
                            <div class="sanjiao_down"></div>
                          </div>
                        </li>
                        <li>
                          <div class="cust-hetong-mesg">
                            <p>合同编号：</p>
                          </div>
                          <div class="cust-hetong-mesg">
                            <p>期限：</p>
                          </div>
                          <div class="cust-hetong-mesg">
                            <p>贷款月利率：</p>
                          </div>
                          <div class="cust-hetong-jiaobiao">
                            <p>快享贷</p>
                            <div class="sanjiao_down"></div>
                          </div>
                        </li>
                      </ul>
                    </el-card>  
                  </div></el-col>
                  <el-col :span="15"><div class="grid-content bg-purple">
                    <el-card class="box-card box-card-hbg">
                      <div slot="header" class="clearfix">
                        <span>贷款信息</span>
                      </div>
                      <div class="daikuan-mesg-list">
                        <div class="daikuan-money-all">应还贷款总额：<span>30,448.27</span></div>
                        <div class="daikuan-money-benjin">本金总额<br/>30,000.00</div>
                        <div class="daikuan-money-lixi">累计利息<br/>448.27</div>
                        <div><el-button type="primary">还款</el-button></div>
                      </div>
                      <ul class="daikuan-mesg-tixing of">
                        <li>
                          <div class="cust-hetong-mesg">
                            <p>提款编号：</p>
                          </div>
                          <div class="cust-hetong-mesg">
                            <p>到期日：</p>
                          </div>
                          <div class="cust-hetong-mesg">
                            <p>剩余本金：</p>
                          </div>
                          <div class="cust-hetong-mesg">
                            <p>累计应还利息：</p>
                          </div>
                          <div class="cust-hetong-mesg">
                            <p>合计：</p>
                          </div>
                          <div class="cust-daikuan-jiaobiao jiaobiao-future">
                            即将到期
                          </div>
                        </li>
                        <li>
                          <div class="cust-hetong-mesg">
                            <p>提款编号：</p>
                          </div>
                          <div class="cust-hetong-mesg">
                            <p>到期日：</p>
                          </div>
                          <div class="cust-hetong-mesg">
                            <p>剩余本金：</p>
                          </div>
                          <div class="cust-hetong-mesg">
                            <p>累计应还利息：</p>
                          </div>
                          <div class="cust-hetong-mesg">
                            <p>合计：</p>
                          </div>
                          <div class="cust-daikuan-jiaobiao jiaobiao-now">
                            已到期
                          </div>
                        </li>  
                      </ul>
                    </el-card>  
                  </div></el-col>
                </el-row> 
                <!-- 第一个tabs结束 -->

              </el-tab-pane>
              <el-tab-pane label="客户资料" name="second" class="bg-purple">客户资料</el-tab-pane>
              <el-tab-pane label="质押车辆" name="third" class="bg-purple">质押车辆</el-tab-pane>
              <el-tab-pane label="贷款信息" name="fourth" class="bg-purple">贷款信息</el-tab-pane>
            </el-tabs>


              <!-- 消息列表 -->


            <el-tabs class="bg-purple">
              <el-tab-pane name="first">
                <span slot="label"><el-badge :value="12" class="item tabs-head-title">
                  <el-button size="small">业务消息</el-button>
                </el-badge></span>
                  <ul class="note-mesg-list">
                    <li>
                      <i></i>
                      <a href="">供应链：初始化/库存管理功能培训 </a>
                      <span>2018-07-30  16:13:10</span>
                    </li>
                    <li>
                      <i class="on"></i>
                      <a href="">供应链：初始化/库存管理功能培训 </a>
                      <span>2018-07-30  16:13:10</span>
                    </li>
                    <li>
                      <i></i>
                      <a href="">供应链：初始化/库存管理功能培训 </a>
                      <span>2018-07-30  16:13:10</span>
                    </li>
                  </ul>

              </el-tab-pane>
              <el-tab-pane name="second">
                <span slot="label"><el-badge :value="12" class="item tabs-head-title">
                  <el-button size="small">系统公告</el-button>
                </el-badge></span>
                配置管理
              </el-tab-pane>
              <el-tab-pane name="third">
                <span slot="label"><el-badge :value="12" class="item tabs-head-title">
                  <el-button size="small">升级公告</el-button>
                </el-badge></span>
              角色管理
              </el-tab-pane>
            </el-tabs>
            <!-- 消息列表结束 -->
            <!-- 面包屑 -->
          <div class="head-guide of">    
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>客户账户管理</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button icon="el-icon-back" circle class="guide-icon-back"></el-button>
          </div>
            <!-- 面包屑结束 -->

        </el-main>
    </el-container>
  </div>
</template>
<script>
import xhr from '../utils/xhr'


export default {
    data() {
      return {

      };
    },
    methods: {

    },
    watch: {

    }
  };
</script>



// WEBPACK FOOTER //
// src/prototype/index.vue